// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// 👉 Coloca aquí tu configuración real:
const firebaseConfig = {
  apiKey: "AIzaSyCUkRTXwp0In6ohJMHUKpbQvwIJB6kR44s",
  authDomain: "asistencia-institucional-5040.firebaseapp.com",
  projectId: "asistencia-institucional-5040",
  storageBucket: "asistencia-institucional-5040.firebasestorage.app",
  messagingSenderId: "61917581738",
  appId: "1:61917581738:web:7ee0161a5e9addcb0adbd3"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar Firestore
const db = getFirestore(app);
export { db };
